import { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

const useIsDesktop = (mediaSize = 812) => {
  const [isDesktop, setIsDesktop] = useState(true);

  // const handleResize = useCallback(() => {
  //         setIsDesktop(window.matchMedia("(min-width: 812px)").matches);
  //     }, [isDesktop],
  // );

  useLayoutEffect(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    function handleResize () {
      setIsDesktop(window.matchMedia(`(min-width: ${mediaSize}px)`).matches);
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [mediaSize]);

  return isDesktop;
};

useIsDesktop.propTypes = {
  mediaSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default useIsDesktop;
